'use es6';

import PublicApp from './PublicApp';
require.context('bender-url!../images', true);
new PublicApp(window.location.href).start();